// delegated-g3-directive-scope-check.ts — 06k C7b (P2, B2): Bảng G3 ủy nhiệm
// kiểm LẠI lúc xử lý directive (tick boundary) — directive `chat_delegated` + g3
// ghi tay vào inbox, hoặc config đổi sau khi approve, vẫn không tới approveGate.
// `delegatedG3Scope` vắng (caller chưa nối config) ⇒ từ chối, fail-closed.
import {
  evaluateDelegatedG3Scope,
  intactDeployTargetSinceG0,
} from "./delegated-g3-approve-scope-guard.js";
import { markDirectiveProcessed } from "./directive-inbox.js";
import { knownValuesFor } from "./mission-secrets-test-env-loader.js";
import type { ReleaseConfig } from "./release-manifest-hash.js";
import type { Directive } from "./schemas/directive-schema.js";

/** Điền ở supervisor-mission-run.ts cạnh g2Decision: cùng `config.release` G3 leg dùng. */
export interface DelegatedG3Scope {
  release?: ReleaseConfig;
  /** Known-values của run (`knownValuesFor`) — che `rationale` khi ghi journal. */
  secretValues: string[];
}

/** B2/1(j): `config.release` của run + known-values (`knownValuesFor`, vắng ⇒ `[]`). */
export async function delegatedG3ScopeFor(
  config: { release?: ReleaseConfig },
  missionId: string,
): Promise<DelegatedG3Scope> {
  return { release: config.release, secretValues: await knownValuesFor(missionId) };
}

const stringList = (v: unknown): string[] | undefined =>
  Array.isArray(v) && v.every((t) => typeof t === "string") ? (v as string[]) : undefined;

/** `true` ⇒ đã từ chối + đánh dấu processed (caller `continue`). */
export async function rejectOutOfScopeDelegatedG3(
  directive: Directive,
  input: { controlRoot: string; delegatedG3Scope?: DelegatedG3Scope },
  rejected: Array<{ directiveId: string; reason: string }>,
  now: () => Date,
): Promise<boolean> {
  if (directive.source !== "chat_delegated" || directive.payload.gate !== "g3") return false;
  const scope = input.delegatedG3Scope;
  let reason: string | undefined;
  if (scope === undefined) {
    reason = "G3 ủy nhiệm: run không có phạm vi G3 ủy nhiệm (delegatedG3Scope vắng) — từ chối.";
  } else {
    const expires = directive.payload.expires_at;
    const verdict = evaluateDelegatedG3Scope({
      targets: stringList(directive.payload.targets),
      expires: typeof expires === "string" ? expires : undefined,
      release: scope.release,
      deployTarget: await intactDeployTargetSinceG0(input.controlRoot),
      now: now(),
    });
    reason = verdict.ok ? undefined : verdict.reason;
  }
  if (reason === undefined) return false;
  rejected.push({ directiveId: directive.directive_id, reason });
  await markDirectiveProcessed(input.controlRoot, directive.directive_id, now);
  return true;
}
